<template>
  <div>
    <el-col :span="24">
      <div>
        <div class="search-content">
          <el-col :span="24" class="toobar">
            <el-col :span="4">
              <el-date-picker size="small" style="width:215px;"
                              v-model="searchdatevalue"
                              type="daterange" :value-format="'yyyy-MM-dd'"
                              align="left" :unlink-panels="true"
                              range-separator="至" :clearable="false"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
              </el-date-picker>
            </el-col>
            <el-col :span="4">
              <el-select v-model="independentserial" filterable size="small">
                <el-option v-for="item in idd" :key="item.serialnum"
                           :label="item.dname"
                           :value="item.serialnum">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="14">
              <el-button type="primary" v-on:click="bindGrid" size="mini">搜索</el-button>
              <el-button type="warning" @click="excelPort" size="mini">导出</el-button>
            </el-col>
          </el-col>
        </div>
        <el-table :data="tableData" :height="elheight"  size="mini"  border style="width: 100%;">
          <el-table-column label="部门" align="left" header-align="center" width="130" prop="dname" fixed></el-table-column>
          <el-table-column label="人员" align="left" header-align="center" width="90" prop="uname" fixed></el-table-column>
          <el-table-column label="岗位" align="left" header-align="center" width="160" prop="erpserial" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="订单量" align="right" header-align="center">
            <template slot-scope="scope">{{scope.row['count']}}</template>
          </el-table-column>
          <el-table-column label="商品数" align="right" header-align="center">
            <template slot-scope="scope">{{scope.row['number']}}</template>
          </el-table-column>
          <el-table-column :label="item.name" v-for="item in coloum" :key="item.code" header-align="center">
            <template slot-scope="scope">{{scope.row[item.code]}}</template>
          </el-table-column>
        </el-table>
      </div>
    </el-col>
  </div>
</template>
<script>

  import {machineworkload} from '@/api/set/csagreement';
  import {exportExcel} from '@/api/file'
  import {independentDept} from '@/api/set/dept';


  export default {
    name: 'WorkloadMachine',
    data() {
      return {
        elheight: '300',
        tableData: [],
        searchdatevalue: [],
        yearflag: '',//年份
        independentserial: 'all',
        coloum: [],
      }
    },
    props: {
      roletype: {
        default: "" //角色菜单信息， 取值：order 、 store ， 分别对应订单、仓库  等菜单角色
      }
    },
    methods: {
      bindGrid() {//绑定列表
        this.tableData = [];
        this.coloum = [];
        var startDate = new Date(this.searchdatevalue[0]);
        var endDate = new Date(this.searchdatevalue[1]);
        var preDate = endDate.getMonth() >= 4 ? new Date(endDate.getFullYear() + '-' + (endDate.getMonth() + 1 - 4) + '-' + endDate.getDate())
          : new Date((endDate.getFullYear() - 1) + '-' + (12 + endDate.getMonth() + 1 - 4) + '-' + endDate.getDate());
        if (startDate < preDate) {
          this.$message({
            message: '单次查询时间跨度最大为120天！',
            type: 'error'
          })
          return false;
        }

        machineworkload({
          yearflag: '',
          begindate: (startDate.getFullYear()+'-'+(startDate.getMonth()+1)+'-'+startDate.getDate()) + " 0:00:00",
          enddate: (endDate.getFullYear()+'-'+(endDate.getMonth()+1)+'-'+endDate.getDate())  + ' 23:59:59',
          independentserial: this.independentserial
        }).then(response => {
          var th = this.tableHeight(90);
          this.elheight = this.elheight == th ? (th - 1) : th;

          var data = response.data.obj
          for (var i in data) {
            var caseStep = '';
            for (var j in this.coloum) {
              if (this.coloum[j].code == data[i].dserial) {
                caseStep = this.coloum[j].code;
                break;
              }
            }
            if (caseStep == '') {
              this.coloum.push({name: data[i].remark, code: data[i].dserial})
              caseStep = data[i].dserial;
            }

            var hasValue = false;
            for (let j in this.tableData) {
              if (this.tableData[j].uguid == data[i].uguid) {
                this.tableData[j]['number'] += parseInt(data[i].totalnumber)
                this.tableData[j]['count'] += parseInt(data[i].insub)
                if (this.tableData[j][caseStep] > 0)
                  this.tableData[j][caseStep] += parseInt(data[i].totalnumber)
                else {
                  this.tableData[j][caseStep] = parseInt(data[i].totalnumber)
                }
                hasValue = true;
                break;
              }
            }
            if (!hasValue) {
              data[i]['number'] = parseInt(data[i].totalnumber)
              data[i]['count'] = parseInt(data[i].insub)
              data[i][caseStep] = parseInt(data[i].totalnumber);
              this.tableData.push(data[i])
            }
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      excelPort() {
        var startDate = new Date(this.searchdatevalue[0]);
        var endDate = new Date(this.searchdatevalue[1]);
        var name = (startDate.getFullYear()+'-'+(startDate.getMonth()+1)+'-'+startDate.getDate())+'~'+(endDate.getFullYear()+'-'+(endDate.getMonth()+1)+'-'+endDate.getDate()) + '工作量明细';
        let data = this.tableData;
        let header1 = ["部门", "人员", "岗位", "订单量", "商品数"];
        let column1 = ["dname", "uname", "erpserial", "count", "number"];
        for (let i in this.coloum) {
          header1.push(this.coloum[i].name);
          column1.push(this.coloum[i].code);
        }
        this.$exportExcel(header1, column1, data, name);
      },
    },
    mounted() {
      var end = new Date();//当天
      var year = end.getFullYear();
      var month = end.getMonth() + 1;
      this.searchdatevalue = [ year + '-' + month + '-1', year + '-' + month + '-' + end.getDate()];
      this.yearflag = ''
      independentDept().then(response => {
        this.idd = response.data.obj
        this.idd.unshift({serialnum: "all", dname: "全部"})
        this.bindGrid();
      })
    },
    components: {}
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/WorkloadMachine.vue